import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ChangePass from "../front-components/ChangePass";
import { useCustomerContext } from "../../context/CustomerContext";

export default function Menu({
  title = "My Account",
  subtitle = "Manage your profile and bookings.",
}) {
  const [changePassodal, setChangePassModal] = useState(false);
  const location = useLocation();
  const { customerData } = useCustomerContext();
  const customerName = customerData?.name || "Nexways Customer";
  const customerInitials = customerName
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join("") || "NC";

  const closeLoginModal = (status) => {
    setChangePassModal(status);
  };

  return (
    <>
      {changePassodal && (
        <ChangePass show={changePassodal} handleClose={closeLoginModal} />
      )}
      <div className="account-hero">
        <div className="account-hero-main">
          <span className="account-hero-avatar">{customerInitials}</span>
          <div className="account-hero-copy">
            <span className="account-kicker">
              <i className="fa fa-shield-alt"></i> Secure customer portal
            </span>
            <h1>{title}</h1>
            <p>{subtitle}</p>
          </div>
        </div>
        <div className="account-nav-pills" aria-label="Account navigation">
          <Link
            to={"/profile"}
            className={`account-nav-pill ${
              location.pathname === "/profile" ? "is-active" : ""
            }`}
          >
            <span><i className="fa fa-user"></i></span>
            <div><small>Account</small><strong>Profile</strong></div>
          </Link>
          <Link
            to={"/bookings"}
            className={`account-nav-pill ${
              location.pathname === "/bookings" ? "is-active" : ""
            }`}
          >
            <span><i className="fa fa-list-alt"></i></span>
            <div><small>Shipments</small><strong>Bookings</strong></div>
          </Link>
          <button
            type="button"
            className="account-nav-pill account-password-button"
            onClick={() => setChangePassModal(true)}
          >
            <span><i className="fa fa-lock"></i></span>
            <div><small>Security</small><strong>Password</strong></div>
          </button>
        </div>
      </div>
    </>
  );
}
